import React from 'react';
import IconDesc from '../my-course/IconDesc';
import { useSelector } from 'react-redux';

function EventBlock({ className, eventDetails, onClick }) {
  const paths = useSelector((state) => state.user.paths);
  let defaultImage = paths.default_event;
  let imagePath = paths.event_path + eventDetails.event_image;

  return (
    <div className={`${className || ''} event-block carousel-block p-0 me-1`}>
      <div className="img-carousel" onClick={onClick}>
        <img
          src={imagePath}
          className="img-fluid"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = defaultImage;
          }}
        />
      </div>
      <div className="desc-carousel" onClick={onClick}>
        <h1>{eventDetails.training_event_name}</h1>
        <p
          dangerouslySetInnerHTML={{
            __html: eventDetails.description,
          }}
        />
        <IconDesc
          paraDesc={`Status: ${eventDetails.status === '1' ? 'Active' : 'Inactive'}`}
        />
      </div>
    </div>
  );
}

export default EventBlock;
